@if (isLoadingPolicies()) {
  <p class="policies-status" role="status">
    {{ 'app.patrol.discord.cockpit.policies.loading' | translate }}
  </p>
} @else if (policiesError() === 'load_failed') {
  <p class="policies-status policies-status--error" role="alert">
    {{ 'app.patrol.discord.cockpit.policies.loadError' | translate }}
  </p>
} @else {
  @if (settings(); as config) {
  <div class="policies">
    @if (isSavingPolicies()) {
      <p class="policies-status" role="status">
        {{ 'app.patrol.discord.cockpit.policies.saving' | translate }}
      </p>
    }
    @if (policiesError() === 'save_failed') {
      <p class="policies-status policies-status--error" role="alert">
        {{ 'app.patrol.discord.cockpit.policies.saveError' | translate }}
      </p>
    }

    <section class="policies__section policies__section--guild">
      <header class="section-header-block">
        <h2 class="section-title">
          {{ 'app.patrol.discord.cockpit.policies.guildSettings' | translate }}
        </h2>
        <p class="section-hint">
          {{ 'app.patrol.discord.cockpit.policies.guildSettingsHint' | translate }}
        </p>
      </header>

      <div class="guild-settings">
        <div class="guild-settings__block">
          <label class="field field--inline">
            <span class="field__label">{{
              'app.patrol.discord.cockpit.policies.defaultPreset' | translate
            }}</span>
            <select
              class="field__select"
              [ngModel]="config.defaultPolicyId"
              (ngModelChange)="onDefaultPolicyChange($event)"
              [disabled]="isSavingPolicies()"
            >
              @for (preset of guildDefaultPresets; track preset) {
                <option [value]="preset">
                  {{ 'app.patrol.discord.cockpit.presets.' + preset | translate }}
                </option>
              }
            </select>
            @if (presetDescriptionKey(config.defaultPolicyId); as descKey) {
              <span class="field__hint">{{ descKey | translate }}</span>
            }
          </label>
        </div>

        <div class="guild-settings__block">
          <p class="guild-settings__group-label">
            {{ 'app.patrol.discord.cockpit.policies.guildOptions' | translate }}
          </p>
          <div class="guild-settings__toggles">
            <label class="toggle-field">
              <input
                type="checkbox"
                [checked]="config.linkRequired"
                [disabled]="isSavingPolicies()"
                (change)="onToggle('linkRequired', $any($event.target).checked)"
              />
              <span class="toggle-field__copy">
                <span class="toggle-field__label">{{
                  'app.patrol.discord.cockpit.policies.linkRequired' | translate
                }}</span>
                <span class="toggle-field__hint">{{
                  'app.patrol.discord.cockpit.policies.linkRequiredHint' | translate
                }}</span>
              </span>
            </label>

            <label class="toggle-field">
              <input
                type="checkbox"
                [checked]="config.reputationEnabled"
                [disabled]="isSavingPolicies()"
                (change)="onToggle('reputationEnabled', $any($event.target).checked)"
              />
              <span class="toggle-field__copy">
                <span class="toggle-field__label">{{
                  'app.patrol.discord.cockpit.policies.reputationEnabled' | translate
                }}</span>
                <span class="toggle-field__hint">{{
                  'app.patrol.discord.cockpit.policies.reputationEnabledHint' | translate
                }}</span>
              </span>
            </label>

            <label class="toggle-field">
              <input
                type="checkbox"
                [checked]="config.failClosedOnAiOutage"
                [disabled]="isSavingPolicies()"
                (change)="onToggle('failClosedOnAiOutage', $any($event.target).checked)"
              />
              <span class="toggle-field__copy">
                <span class="toggle-field__label">{{
                  'app.patrol.discord.cockpit.policies.failClosed' | translate
                }}</span>
                <span class="toggle-field__hint">{{
                  'app.patrol.discord.cockpit.policies.failClosedHint' | translate
                }}</span>
              </span>
            </label>

            <label class="toggle-field">
              <input
                type="checkbox"
                [checked]="config.notificationsEmail"
                [disabled]="isSavingPolicies()"
                (change)="onToggle('notificationsEmail', $any($event.target).checked)"
              />
              <span class="toggle-field__copy">
                <span class="toggle-field__label">{{
                  'app.patrol.discord.cockpit.policies.notifications' | translate
                }}</span>
                <span class="toggle-field__hint">{{
                  'app.patrol.discord.cockpit.policies.notificationsHint' | translate
                }}</span>
              </span>
            </label>
          </div>
        </div>

        <div class="guild-settings__block">
          <p class="guild-settings__group-label">
            {{ 'app.patrol.discord.cockpit.policies.kindSpeechGroup' | translate }}
          </p>
          <p class="section-hint guild-settings__group-hint">
            {{ 'app.patrol.discord.cockpit.policies.kindSpeechGroupHint' | translate }}
          </p>
          <p class="section-hint guild-settings__defaults-hint">
            {{
              'app.patrol.discord.cockpit.policies.kindSpeechDefaults' | translate: kindSpeechDefaultParams
            }}
          </p>
          <div class="guild-settings__toggles">
            <label class="toggle-field">
              <input
                type="checkbox"
                [checked]="config.kindSpeechEnabled"
                [disabled]="isSavingPolicies()"
                (change)="onToggle('kindSpeechEnabled', $any($event.target).checked)"
              />
              <span class="toggle-field__copy">
                <span class="toggle-field__label">{{
                  'app.patrol.discord.cockpit.policies.kindSpeechEnabled' | translate
                }}</span>
                <span class="toggle-field__hint">{{
                  'app.patrol.discord.cockpit.policies.kindSpeechEnabledHint' | translate
                }}</span>
              </span>
            </label>
          </div>
          <dl class="kind-speech-defaults">
            <div class="kind-speech-defaults__row">
              <dt>
                {{
                  'app.patrol.discord.cockpit.policies.kindSpeechMilestoneCount' | translate
                }}
              </dt>
              <dd>{{ kindSpeechDefaultParams.milestone }}</dd>
            </div>
            <div class="kind-speech-defaults__row">
              <dt>
                {{
                  'app.patrol.discord.cockpit.policies.positiveParticipationHourlyLimit'
                    | translate
                }}
              </dt>
              <dd>{{ kindSpeechDefaultParams.hourlyLimit }}</dd>
            </div>
            <div class="kind-speech-defaults__row">
              <dt>
                {{
                  'app.patrol.discord.cockpit.policies.kindSpeechPenaltyCooldown' | translate
                }}
              </dt>
              <dd>{{ kindSpeechDefaultParams.penaltyMinutes }}</dd>
            </div>
            <div class="kind-speech-defaults__row">
              <dt>
                {{
                  'app.patrol.discord.cockpit.policies.kindSpeechDedupeWindow' | translate
                }}
              </dt>
              <dd>{{ kindSpeechDefaultParams.dedupeMinutes }}</dd>
            </div>
          </dl>
        </div>

        <div class="guild-settings__block">
          <label class="field field--inline">
            <span class="field__label">{{
              'app.patrol.discord.cockpit.policies.verifiedRoleName' | translate
            }}</span>
            <input
              class="field__input"
              type="text"
              [ngModel]="config.verifiedRoleName"
              [disabled]="isSavingPolicies()"
              (ngModelChange)="onVerifiedRoleNameChange($event)"
            />
            <span class="field__hint">{{
              'app.patrol.discord.cockpit.policies.verifiedRoleNameHint' | translate
            }}</span>
          </label>
        </div>
      </div>
    </section>

    <section class="policies__section">
      <h2 class="section-title">
        {{ 'app.patrol.discord.cockpit.policies.rolePolicies' | translate }}
      </h2>
      <p class="section-hint">
        {{ 'app.patrol.discord.cockpit.policies.rolePoliciesHint' | translate }}
      </p>

      @if (discordRoles().length > 0) {
        <div class="table-wrap">
          <table class="policy-table policy-table--roles">
            <thead>
              <tr>
                <th>{{ 'app.patrol.discord.cockpit.policies.colRole' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.policies.colPolicy' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.policies.colMembers' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (row of discordRoles(); track row.discordRoleId) {
                <tr>
                  <td>
                    <span class="role-chip" [style.--role-color]="row.roleColor">
                      {{ row.roleName }}
                    </span>
                  </td>
                  <td>
                    <select
                      class="field__select field__select--compact"
                      [ngModel]="rolePolicyValue(row.discordRoleId)"
                      (ngModelChange)="onRolePolicyChange(row.discordRoleId, $event)"
                      [disabled]="isSavingPolicies()"
                    >
                      @for (preset of rolePresets; track preset) {
                        <option [value]="preset">
                          @if (preset === 'inherit') {
                            {{
                              'app.patrol.discord.cockpit.policies.inheritGuildDefault'
                                | translate
                            }}
                          } @else {
                            {{
                              'app.patrol.discord.cockpit.presets.' + preset | translate
                            }}
                          }
                        </option>
                      }
                    </select>
                  </td>
                  <td>{{ row.memberCount | number }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <p class="empty-hint">
          {{ 'app.patrol.discord.cockpit.policies.noRoles' | translate }}
        </p>
      }
    </section>

    <section class="policies__section">
      <h2 class="section-title">
        {{ 'app.patrol.discord.cockpit.policies.channelPolicies' | translate }}
      </h2>
      <p class="section-hint">
        {{ 'app.patrol.discord.cockpit.policies.channelPoliciesHint' | translate }}
      </p>

      @if (moderatedChannels().length > 0) {
        <div class="table-wrap">
          <table class="policy-table policy-table--channels">
            <thead>
              <tr>
                <th>{{ 'app.patrol.discord.cockpit.policies.colChannel' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.policies.colType' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.policies.colPolicy' | translate }}</th>
                <th>{{ 'app.patrol.discord.cockpit.policies.colAccess' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (row of moderatedChannels(); track row.discordChannelId) {
                <tr>
                  <td>{{ row.channelName }}</td>
                  <td>
                    {{
                      'app.patrol.discord.cockpit.channelTypes.' + row.channelType
                        | translate
                    }}
                  </td>
                  <td>
                    <select
                      class="field__select field__select--compact"
                      [ngModel]="channelPolicyValue(row.discordChannelId)"
                      (ngModelChange)="onChannelPolicyChange(row.discordChannelId, $event)"
                      [disabled]="isSavingPolicies()"
                    >
                      @for (preset of channelPresets; track preset) {
                        <option [value]="preset">
                          @if (preset === 'inherit') {
                            {{
                              'app.patrol.discord.cockpit.policies.inheritGuildDefault'
                                | translate
                            }}
                          } @else {
                            {{
                              'app.patrol.discord.cockpit.presets.' + preset | translate
                            }}
                          }
                        </option>
                      }
                    </select>
                  </td>
                  <td class="access-cell">
                    <div class="access-cell__row">
                      <select
                        class="field__select field__select--compact field__select--access"
                        [ngModel]="channelAccessValue(row.discordChannelId)"
                        (ngModelChange)="onChannelAccessChange(row.discordChannelId, $event)"
                        [disabled]="isSavingPolicies()"
                      >
                        @for (mode of channelAccessModes; track mode) {
                          <option [value]="mode">
                            {{
                              'app.patrol.discord.cockpit.policies.access.' + mode
                                | translate
                            }}
                          </option>
                        }
                      </select>
                      @if (channelAccessValue(row.discordChannelId) === 'age_bracket') {
                        <div class="access-age-inline">
                          <span class="access-age-inline__label">{{
                            'app.patrol.discord.cockpit.policies.accessAgesLabel' | translate
                          }}</span>
                          <input
                            class="field__input field__input--age"
                            type="number"
                            min="0"
                            max="120"
                            [ngModel]="channelAccessAge(row.discordChannelId).minAge"
                            [disabled]="isSavingPolicies()"
                            (ngModelChange)="
                              onChannelAccessAgeChange(row.discordChannelId, 'minAge', $event)
                            "
                          />
                          <span class="access-age-sep">–</span>
                          <input
                            class="field__input field__input--age"
                            type="number"
                            min="0"
                            max="120"
                            [ngModel]="channelAccessAge(row.discordChannelId).maxAge"
                            [disabled]="isSavingPolicies()"
                            (ngModelChange)="
                              onChannelAccessAgeChange(row.discordChannelId, 'maxAge', $event)
                            "
                          />
                          <span class="access-age-inline__arrow" aria-hidden="true">→</span>
                          <span
                            class="access-age-role"
                            [attr.title]="
                              'app.patrol.discord.cockpit.policies.colDiscordRole' | translate
                            "
                          >
                            {{ channelAccessAge(row.discordChannelId).roleName }}
                          </span>
                          @if (hasChannelAccessAgeDraft(row.discordChannelId)) {
                            <button
                              type="button"
                              class="access-age-confirm"
                              [disabled]="isSavingPolicies()"
                              (click)="onConfirmChannelAccessAge(row.discordChannelId)"
                            >
                              {{
                                'app.patrol.discord.cockpit.policies.confirmAgeAccess'
                                  | translate
                              }}
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <p class="empty-hint">
          {{ 'app.patrol.discord.cockpit.policies.noChannels' | translate }}
        </p>
      }
    </section>
  </div>
  }
}
